// Per-listing-type commission rates. Authored as a CJS module so the
// server (Node, require) and the client (Webpack, default-import)
// share a single source of truth without duplicating values.
//
// Shape (per entry):
//   providerCommissionPercentage — % deducted from the provider's payout
//   customerMarkupPercentage     — % baked into the customer-facing price
//                                  (a markup, not a separate commission line)
//
// Operator-owned listings short-circuit to zero in the resolver and do
// not consult this table — see server/api-util/commissionResolver.js.
//
// Adding a new listing type: add an entry here, then add the matching
// `commission: listingTypeCommissions['<type>']` reference on the
// listing type entry in src/config/configListing.js.

module.exports = {
  'event-kit-rental': {
    providerCommissionPercentage: 10,
    customerMarkupPercentage: 15,
  },
};
